var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mapKeys } from 'lodash';
import { StoryType } from '../models/story-type.enum';
import { storyType } from '../state/story-type';
function moduleNameFromStoryId(storyId) {
    return storyType(storyId) === StoryType.Bookmark
        ? storyId
        : storyId.split('/').pop();
}
export function mergeReflections(currentReflections, newReflections, currentStoryId, newStoryId) {
    currentReflections = currentReflections || {};
    newReflections = newReflections || {};
    // if the current id already has a namespace, return it.
    // otherwise, namespace as normal
    var namespaceReflectionId = function (storyId, currentId) {
        var isAlreadyNamespaced = function (id) { return id.includes('/'); };
        return isAlreadyNamespaced(currentId)
            ? currentId
            : moduleNameFromStoryId(storyId) + "/" + currentId;
    };
    return __assign({}, mapKeys(currentReflections, function (value, key) {
        return namespaceReflectionId(currentStoryId, key);
    }), mapKeys(newReflections, function (value, key) {
        return namespaceReflectionId(newStoryId, key);
    }));
}
